import { useParams, Link, useNavigate } from "react-router-dom";
import { Col, Row, Button, ButtonGroup } from 'react-bootstrap';
import { useState, useEffect, useCallback } from 'react';

// import PreviousNext from '../common/previous-next';
import BasicSpinner from '../common/basic-spinner';
// import ListView from '../common/list-view';
import PaginatedList from '../common/pagination';


import ItemDetails from '../item/item-details';

import { fetchPublicItem, fetchPublicItemParents, fetchPublicItemChildren } from '../../utils/fetch-helpers';
import { useAuth } from "../../utils/auth-provider";

//================================================================

export default function ItemPage(){

  const navigate = useNavigate();
  const user = useAuth();
  const params = useParams();

  const [parents, setParents] = useState(null);
  // const [items, setItems] = useState(null);
  const [item, setItem] = useState(null);

  const [itemImages, setItemImages] = useState(null);
  const [loading, setLoading] = useState(true);

  //----------------------------------------------------------------

  const fetchItem = useCallback( async (itemId, signal) => {
    setItem(await fetchPublicItem(itemId, signal));
  },[params.itemId]);

  //----------------------------------------------------------------

  const fetchItemImages = useCallback( async (itemId, signal) => {
    const fetchResult = await fetchPublicItemChildren(itemId, signal);
    setItemImages(fetchResult['images']);
  }, [item]);

  //----------------------------------------------------------------

  const fetchParents = useCallback(async (itemId, signal) => {
    setParents(await fetchPublicItemParents(itemId, signal));
  },[item]);

  //----------------------------------------------------------------

  useEffect(() => {
    if(!item) return;

    const abortController = new AbortController();
    const signal = abortController.signal;

    fetchParents(item._id, signal);
    fetchItemImages(item._id, signal);

    return () => abortController.abort();
  }, [item]);

  //----------------------------------------------------------------

  useEffect(() => {
    const abortController = new AbortController();
    const signal = abortController.signal;

    fetchItem(params.itemId, signal);

    return () => abortController.abort();
  }, [params.itemId]);

  //----------------------------------------------------------------

  return(
    <>
      {/*<PreviousNext
        objects={items}
        currentObject={item}
        onClick={setCurrentItem}
        basePath={`/item`}
      />*/}

      { !item ?
        <BasicSpinner className="mb-4 col text-center" text={'Loading...'} />
        :
        <>

          <Row className="mb-2 align-items-center">
            <Col className="h4 text-truncate" sm={9}>
              <b>{"Item: "}</b>{item.name || ""}
            </Col>
            { user.isAuthenticated &&
              <Col sm={3}>
                <Link to={`/dashboard/item/${item._id}`}>
                  <Button className="text-nowrap w-100">
                    View Your Item
                  </Button>
                </Link>
              </Col>
            }
          </Row>

          <ItemDetails item={item}/>

          <Row className='mb-2 align-items-center'>
            <Col>
              <Button
                className="w-100"
                onClick={() => navigate(-1)}
              >
                Back
              </Button>
            </Col>
            <Col>
              <Button
                className="w-100"
                onClick={() => navigate(1)}
              >
                Forward
              </Button>
            </Col>
          </Row>

          {/* Images Section */}
          {itemImages && itemImages.length > 0 &&
            <>
              <hr />
              <Row className="mb-3 align-children-center">
                <Col className="h5 my-0 text-start">Images</Col>
              </Row>
              <PaginatedList
                list={itemImages}
                type="image"
              />
            </>
          }
          {/* End Image Section */}

          {/* Parents Section*/}
          { parents && parents['collections'].length > 0 &&
            <>
              <hr />
              <Row className="mb-3 align-children-center">
                <Col className="h5 my-0 text-start">Parent Collections</Col>
              </Row>

              <PaginatedList
                list={parents['collections']}
                name="Collections"
                type="collection"
              />
            </>
          }
          {/* End Parents Section*/}

        </>
      }

    </>
  );
}
